import { ReactNode } from 'react';

export enum SoftAlertType {
  inProgress = 'inProgress',
  error = 'error',
  success = 'success'
}

export interface Alert {
  id: number;
  message: string | ReactNode;
  type: SoftAlertType;
  duration: number;
  systemType?: string;
}

export type ShowShowFn = (
  message: string | ReactNode,
  type?: SoftAlertType,
  duration?: number,
  systemType?: string
) => number;

export interface AlertContextValue {
  showAlert: ShowShowFn;
  hideAlert: (id: number) => void;
}
